<template>
  <v-container>
    <h1>LightYear</h1>
    <v-card class="pa-5" v-for="(card, x) in filteredDeck" :key="x">
      <v-card v-if="card.mid == 1451282465113" color="">
        <p v-html="parseTest(card.content.Text, false)"></p>
        <p v-html="parseTest(card.content.Text, true)"></p>
        <img v-for="(i, y) in getSRC(card.content.Extra)" :key="y" :src="'https://omentum.s3.us-east-1.amazonaws.com/anki_lightyear/' + i"/>
      </v-card>
      <v-card  v-if="card.mid == 1481327979421" color="">
        <p v-html="card.content.Front"></p>
        <img v-for="(i, y) in getSRC(card.content.Front)" :key="y" :src="'https://omentum.s3.us-east-1.amazonaws.com/anki_lightyear/' + i"/>
        <p v-html="card.content.Back"></p>
        <img v-for="(i, y) in getSRC(card.content.Back)" :key="y" :src="'https://omentum.s3.us-east-1.amazonaws.com/anki_lightyear/' + i"/>
      </v-card>



    </v-card>

  </v-container>

</template>
<script>
import LYData from '@/lightyear/data.json'
export default {
  name: 'Lightyear',
  data() {
    return {
      raw: LYData

    }
  },
  computed: {
    filteredDeck() {
      return LYData.filter(entry => {
        return entry.tags[2] == 'pancreas'
      })
    }
  },
  methods: {
    getSRC(str){
      var m,
          urls = [],
          rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;

      while ( m = rex.exec( str ) ) {
          urls.push( m[1] );
      }
      return urls
    },
    parseTest(inv, showAnswer) {
      let result = []
      let entries = inv.match(/{{([^}]+)}}/g)
      inv.match(/{{([^}]+)}}/g).forEach(item => result.push(item.replace("}}","").split("::")))

      var str = (' ' + inv).slice(1)

      entries.forEach((x,i) => {
        if (!showAnswer) {
          if (result[i].length > 2) {
            str = str.replace(x, "<span class='grey--text closure'>" + result[i][2] + "</span>" )
          }
          else {
            str = str.replace(x, "<span class='white--text closure'>" + result[i][1] + "</span>" )
          }
        }
        else {
          str = str.replace(x, "<span class='blue--text'>" + result[i][1] + "</span>")
        }


      })


      return str
    }
  }
}
</script>
<style>
.closure {
  border: 3px solid #ff9800;
}
</style>
